import React, { useContext } from "react";
import AboutUs from "../images/newimg/ab.png";
import FadeImg from "../images/newimg/fade.png";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import MissionIMG from "../images/newimg/mission.jpg";
import Mission1IMG from "../images/newimg/mission1.jpg";
import Mission2IMG from "../images/newimg/mission2.jpg";
import OrangeIMG from "../images/newimg/orange.png";
import AOS from "aos";
import GradientIMG from "../images/newimg/gradient3.jpg";
import Gradient1IMG from "../images/newimg/gradient4.png";
import UserIMG from "../images/newimg/users.png";
import ChartIMG from "../images/newimg/chart.png";
import Drive1 from "../images/newimg/drive1.svg";
import Drive2 from "../images/newimg/drive2.svg";
import Drive3 from "../images/newimg/drive3.svg";
import Drive4 from "../images/newimg/drive4.svg";
import Drive5 from "../images/newimg/drive5.svg";
import { Accordion } from "react-bootstrap";
import WayIMG from "../images/newimg/way.jpg";
import { Link } from "react-router-dom";

import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import { trackScreenView, trackButtonClick, getUserTrackingParams } from "../../utility/services/analyticsService";

const About = () => {
  const { setAuthRole, user } = useContext(AuthContext);
  const { enctyptDataFun } = Functions();

  const isUserDetails = user.details != null;

  // LOGICAL VARIABLES
  React.useEffect(() => {
    trackScreenView("about_screen", { screen_name: "About Us", ...getUserTrackingParams(user) });
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);

  const set_login_role = () => {
    setAuthRole("Patient");
    localStorage.setItem("E_C_R_O_L_E", enctyptDataFun("Patient"));
  };
  return (
    <>
      <BannerSection banner={Banner} name={"Home"} title={"About us"} />
      <section id="about" className="py-5 aboutUs aboutUsNew">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-md-6 position-relative order-1 order-sm-0 order-md-0 order-lg-0"
              // data-aos="fade-left"
              // data-aos-duration="1500"
              // data-aos-delay="100"
            >
              <img src={AboutUs} alt="" className="img-fluid aboutImgNew" />
              <img src={FadeImg} alt="" className="img-fluid posFade" />
            </div>
            <div
              className="col-md-6 mb-3 mb-sm-0 mb-lg-0 mb-mb-0"
              // data-aos="fade-right"
              // data-aos-duration="1500"
              // data-aos-delay="100"
            >
              <h2>
                <span>Who we are</span>
              </h2>
              <p>
                At <strong>eCare Therapy</strong>, we’re redefining how people
                access and experience mental health care. Our mission is simple:
                <strong>
                  {" "}
                  make therapy accessible, welcoming, and tailored to you
                </strong>
                . No matter where you are or what you’re going through, we’re
                here to help you connect with therapists who truly understand
                and support you.
              </p>
              <p>
                Join us on a journey toward mental well-being—one conversation,
                one step, one connection at a time.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-5 mission"
        style={{ backgroundImage: `url(${MissionIMG})` }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2>
                <span>Our mission</span>
              </h2>
              <p className="para mb-4 mb-sm-0 mb-lg-0 mb-mb-0">
                We believe that mental health is just as important as physical
                health. That’s why we’re breaking down barriers to care,
                creating a platform that champions accessibility, choice, and
                quality. From finding the right therapist to connecting on your
                terms, eCare Therapy is committed to empowering you with the
                support you deserve.
              </p>
            </div>
            <div className="col-md-6 position-relative">
              <img src={Mission1IMG} alt="" className="img-fluid misImg" />
              <div className="mis_comment">
                <p className="para1">
                  eCare Therapy is the easiest platform to find and select a
                  therapist. It’s simple, quick, and incredibly user-friendly!"
                </p>
                <span>— Nadia Kojima</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-5 matter_box"
        style={{ backgroundImage: `url(${GradientIMG})` }}
      >
        <div className="container">
          <div className="row align-items-center mb-5">
            <div className="col-md-6 position-relative order-1 order-sm-0 order-md-0 order-lg-0 mbCenter">
              <img src={Mission2IMG} alt="" className="img-fluid misImg" />
              <img src={OrangeIMG} alt="" className="img-fluid orangeCircle" />
            </div>
            <div className="col-md-6 mb-4 mb-sm-0 mb-lg-0 mb-mb-0 ">
              <h2>
                <span>Why therapy matters</span>
              </h2>
              <p className="para">
                Therapy is more than just talking—it’s about transformation.
                Studies show that{" "}
                <strong>
                  75% of people who attend therapy see improvements in their
                  mental health
                </strong>
                . Whether it’s managing stress, healing from trauma, or
                navigating relationships, therapy provides tools to help you
                lead a healthier, more fulfilling life.
              </p>
              <p className="para">
                Unfortunately, stigma often prevents people from seeking the
                help they need. At eCare Therapy, we’re committed to changing
                that narrative. Therapy is not a sign of weakness—it’s a step
                toward strength, resilience, and growth.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="mb-1 mb-md-5">
                <span>Did you know?</span>
              </h2>
              <div className="row justify-content-center">
                <div className="col-md-8">
                  <div className="row mateBox mb-5">
                    <div className="col-md-6">
                      <img
                        src={UserIMG}
                        alt=""
                        className="img-fluid imgPosMinus"
                      />
                      <p>
                        1 in 5 people will face a mental health challenge this
                        year.
                      </p>
                    </div>
                    <div className="col-md-6">
                      <img src={ChartIMG} alt="" className="img-fluid" />
                      <p>
                        Over 57 million adults in the U.S. experience mental
                        health issues, yet more than half don’t seek help.
                      </p>
                    </div>
                  </div>
                  <h4>
                    What we're saying is—it’s okay to ask for help. Needing
                    support is part of being human. Therapy isn’t a sign of
                    struggle; it’s a sign that you care enough to grow and
                    become the best version of yourself.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="drive_box bg-white drive_boxNew">
        <div className="container">
          <h2 className="text-center drive_mb position-relative z-1">
            <span>What drives us</span>
          </h2>
          <div className="row justify-content-center mb-0 mb-sm-5 position-relative z-1">
            <div className="col-md-4">
              <div className="drive_container">
                <div className="drive_icon">
                  <img src={Drive1} alt="" />
                </div>
                <h4>Accessibility</h4>
                <p>Making therapy available to everyone, everywhere.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="drive_container">
                <div className="drive_icon">
                  <img src={Drive2} alt="" />
                </div>
                <h4>Empathy</h4>
                <p>
                  Creating a space where compassion and understanding come
                  first.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="drive_container">
                <div className="drive_icon">
                  <img src={Drive3} alt="" />
                </div>
                <h4>Personalization</h4>
                <p>
                  Connecting you with a therapist who truly fits your needs.
                </p>
              </div>
            </div>
            <div className="col-md-8">
              <div className="row mt-0 mt-md-5">
                <div className="col-md-6">
                  <div className="drive_container">
                    <div className="drive_icon">
                      <img src={Drive4} alt="" />
                    </div>
                    <h4>Confidentiality</h4>
                    <p>Providing a secure, judgment-free environment.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="drive_container">
                    <div className="drive_icon">
                      <img src={Drive5} alt="" />
                    </div>
                    <h4>Empowerment</h4>
                    <p>Supporting your journey toward healing and growth.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row position-relative z-1 pt-0 pt-sm-0 pt-md-5">
            <div className="col-md-6 mb-0">
              <h2 className="drive_mb drive_mbMobile">
                <span>FAQ</span>
              </h2>
            </div>
            <div className="col-md-6 mb-0">
              <div className="faqBox">
                <h3>ABOUT THE PLATFORM</h3>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      What is eCare Therapy, and how does it work?
                    </Accordion.Header>
                    <Accordion.Body>
                      eCare Therapy is an online platform connecting individuals
                      with licensed therapists who meet their specific needs.
                      You can browse therapists by specialties, availability,
                      and other preferences. Once you find a match, book a
                      session in a format that works for you—video, audio, or
                      chat.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      Do I need a subscription to use the platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      No subscription is required. You only pay for the sessions
                      you book, with no long-term commitments
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      How do I choose the right therapist for me?
                    </Accordion.Header>
                    <Accordion.Body>
                      Explore therapist profiles, which include reviews,
                      specialties, and bios, to find someone who feels like the
                      right fit. You can filter based on your needs and
                      preferences to make the best choice.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      What type of sessions are available?
                    </Accordion.Header>
                    <Accordion.Body>
                      You can choose from video, audio, or chat sessions. Pick
                      the format that makes you feel most comfortable.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      Can I use insurance for my sessions?
                    </Accordion.Header>
                    <Accordion.Body>
                      eCare Therapy works on a pay-as-you-go model, which means
                      no long-term commitments or complicated insurance
                      paperwork. <br />
                      <br />
                      By not involving insurance, we can keep our prices
                      affordable and flexible. You only pay for the sessions you
                      book, with no surprise fees or membership requirements.
                      This approach also gives you greater privacy and control
                      over your mental health journey, without needing to
                      disclose personal details to your insurance company.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <h3 className="mt-4">ABOUT THERAPY</h3>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      What should I expect in my first session?
                    </Accordion.Header>
                    <Accordion.Body>
                      Your first session is an opportunity to share your goals,
                      concerns, and history with your therapist. It’s a chance
                      to ask questions, set expectations, and begin building a
                      comfortable rapport.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      Is therapy right for me?
                    </Accordion.Header>
                    <Accordion.Body>
                      Therapy is for anyone looking to improve their mental
                      well-being, navigate challenges, or grow emotionally.
                      Whether you’re facing stress, relationship issues, or just
                      need someone to talk to, therapy can be a valuable tool.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      How do I prepare for a virtual session?
                    </Accordion.Header>
                    <Accordion.Body>
                      Choose a quiet, comfortable space with minimal
                      distractions. Ensure you have a stable internet connection
                      and test your device beforehand. Have a notebook or pen
                      ready if you’d like to jot down key points.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      What types of issues can therapy help with?
                    </Accordion.Header>
                    <Accordion.Body>
                      Therapy can address a wide range of challenges, including
                      anxiety, depression, stress, grief, trauma, relationship
                      conflicts, substance abuse, self-esteem, and more. It’s
                      also a helpful resource for personal growth and emotional
                      resilience.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      Does therapy work for everyone?
                    </Accordion.Header>
                    <Accordion.Body>
                      While everyone’s experience is different, research shows
                      that the majority of people benefit from therapy. Success
                      often depends on finding the right therapist and being
                      open to the process.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-5 mission mission1"
        style={{ backgroundImage: `url(${MissionIMG})` }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-4 mb-sm-0">
              <h2>
                <span>Your mental health, your way</span>
              </h2>
              <p className="para">
                Real conversations, real connections, real results. Ready to
                start? Explore therapists now and take the first step toward the
                support you deserve.
              </p>
              <Link
                className="btn btn-default hover_orange"
                to={isUserDetails ? "/dashboard" : `/login`}
                onClick={() => {
                  trackButtonClick("get_started_cta", { button_name: "Get Started", screen_name: "About Us", button_position: "bottom" });
                  if (isUserDetails) return;
                  set_login_role();
                }}
              >
                Get started
              </Link>
            </div>
            <div className="col-md-6 position-relative">
              <img src={WayIMG} alt="" className="img-fluid misImg1" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
